import "./style.css";
import Header from "../../../componente/header";
import { useState, useEffect } from "react";
import ModalValorVendido from "react-modal";
import api from "../../../services/api";
import Paginacao from "../../../componente/paginacao";
import LoadingScreen from "../../../componente/aguarde";
import { podeInserir } from "../../../componente/permissoes";

function LancTitulo() {
  const { DateTime } = require("luxon");

  const AUTOCOMPLETE_URL = "v1/relatorio/filtro";

  //tela
  const dt = new Date();

  const dt11 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    dt.getDate().toString().padStart(2, "0");
  let time =
    dt.getHours().toString().padStart(2, "0") +
    ":" +
    dt.getMinutes().toString().padStart(2, "0");
  let dtcadastro = dt11 + " " + time;

  const date1 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    dt.getDate().toString().padStart(2, "0");
  const date2 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    dt.getDate().toString().padStart(2, "0");

  const [abusca, setabusca] = useState("");
  const [offset, setOffset] = useState(0);
  const [edtcodequipe, setedtcodequipe] = useState(0);
  const [edtcidade, setedtcidade] = useState("0");
  const [edtuf, setedtuf] = useState("");
  const [dt1, setdt1] = useState(date1);
  const [dt2, setdt2] = useState(date2);
  const [inputValue2, setInputValue2] = useState("");
  const [lista, setlista] = useState([]);
  const [listaequipe, setlistaequipe] = useState([]);
  const [listacidade, setlistacidade] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [inputValue1, setInputValue1] = useState("");
  const [qtdetotalpag, setqtdetotalpag] = useState(0);
  const [codvendedor1, setcodvendedor1] = useState(0);
  const [listaVendedor1, setlistaVendedor1] = useState([]);
  const [tipoPano1, setTipoPano1] = useState("T");
  const [temDebito, setTemDebito] = useState("N");

  const [loading, setLoading] = useState(false);

  //Tela Valor da Venda
  const [showformValorVenda, setshowformValorVenda] = useState(false);
  const [edtNome, setEdtNome] = useState("");
  const [edtValorVendido, setEdtValorVendido] = useState(0);
  const [edtPercComissao, setEdtPercComissao] = useState(0);
  const [edtValorEmpresa, setEdtValorEmpresa] = useState(0);
  const [edtValorBrinde, setEdtValorBrinde] = useState(0);
  const [edtCodContasReceber, setEdtCodContasReceber] = useState(0);
  const [edtStatus, setEdtStatus] = useState("");
  const [edtDescricaoObjeto, setEdtDescricaoObjeto] = useState("");
  const [edtValor, setEdtValor] = useState(0);
  const [edtValorRestante, setEdtValorRestante] = useState(0);
  const [edtCodBanco, setEdtCodBanco] = useState(0);
  const [edtCodMoeda, setEdtCodMoeda] = useState(0);
  const [listaBanco, setListaBanco] = useState([]);
  const [listaMoeda, setListaMoeda] = useState([]);
  const [edtDtPagamento, setEdtDtPagamento] = useState("");
  const [pendencia, setPendencia] = useState(false);
  const [edtCodDetalhe, setedtCodDetalhe] = useState(0);
  const [edtValorTemp, setEdtValorTemp] = useState(0);

  const ListarTitulo = async () => {
    setLoading(true);
    try {
      const response = await api
        .get("v1/operacoes/manutencaotitulo", {
          params: {
            busca: abusca,
            offset,
            codequipe: edtcodequipe,
            codvendedor: codvendedor1,
            cidade: edtcidade,
            uf: edtuf,
            tipopano: tipoPano1,
            dt1,
            dt2,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        });

      setlista(response.data);
    } catch (error) {
      console.log("ops! ocorreu um erro: " + error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    ListarTitulo();
  }, [
    abusca,
    dt1,
    dt2,
    edtcodequipe,
    tipoPano1,
    codvendedor1,
    edtcidade,
    offset,
  ]);

  function ListarPaginas() {
    api
      .get("repasse/pagtotal5", {
        params: {
          busca: abusca,
          codequipe: edtcodequipe,
          codvendedor: codvendedor1,
          cidade: edtcidade,
          tipopano: tipoPano1,
          uf: edtuf,
          dt1,
          dt2,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setqtdetotalpag(response.data.paginatotal);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(() => {
    ListarPaginas();
  }, [lista]);

  function closeModal() {
    setshowformValorVenda(false);
  }

  function FormataData(props) {
    return props
      ? DateTime.fromISO(props).plus({ hours: 3 }).toFormat("dd/MM/yyyy")
      : null;
  }

  const handleInputChangeEquipe = async (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (value.length > 2) {
      try {
        const response = await api.get(`${AUTOCOMPLETE_URL}/equipe`, {
          params: { busca: value },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        });
        setlistaequipe(response.data);
      } catch (error) {
        console.log("ops! ocorreu um erro: " + error);
      }
    } else {
      setlistaequipe([]);
      setedtcodequipe(0);
    }
  };

  const handleInputChangeVendedor1 = async (e) => {
    const value = e.target.value;
    setInputValue1(value);

    if (value.length > 2) {
      setLoading(true);
      try {
        const response = await api.get(`${AUTOCOMPLETE_URL}/vendedor1`, {
          params: { busca: value },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        });
        setlistaVendedor1(response.data);
      } catch (error) {
        console.log("ops! ocorreu um erro: " + error);
      } finally {
        setLoading(false);
      }
    } else {
      setlistaVendedor1([]);
      setcodvendedor1(0);
    }
  };

  const handleCidadeSelecionado = (cid) => {
    setInputValue2(cid.cidade + " - " + cid.uf);
    setedtcidade(cid.cidade);
    setedtuf(cid.uf);
    setOffset(0);
    setlistacidade([]);
  };

  const handleInputChangeCidade = async (e) => {
    const value = e.target.value;
    setInputValue2(value);

    if (value.length > 2) {
      try {
        const response = await api.get(`${AUTOCOMPLETE_URL}/cidade`, {
          params: { busca: value },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        });
        setlistacidade(response.data);
      } catch (error) {
        console.log("ops! ocorreu um erro: " + error);
      }
    } else {
      setlistacidade([]);
      setedtcidade("0");
      setedtuf("");
    }
  };

  const handleEquipeSelecionado = (equip) => {
    setInputValue(equip.descricao);
    setedtcodequipe(equip.codequipe);
    setOffset(0);
    setlistaequipe([]);
  };

  const handleVendedor1Selecionado = (ven) => {
    setInputValue1(ven.nome);
    setcodvendedor1(ven.codfuncionario);
    setlistaVendedor1([]);
  };

  async function openModalValorVendido(item) {
    api
      .get("/v1/operacoes/repasseum", {
        params: {
          codcontasreceber: item.codcontasreceber,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setshowformValorVenda(true);
        setEdtNome(item.cliente);
        setEdtValorVendido(response.data.valorvendido);
        setEdtPercComissao(response.data.perccomissao);
        setEdtValorEmpresa(response.data.valorempresa);
        setEdtValorBrinde(response.data.valorbrinde);
        setEdtCodContasReceber(item.codcontasreceber);
        setEdtStatus("P");
        setEdtDescricaoObjeto("");
        setEdtValorRestante(0);
        setEdtCodBanco(0);
        setEdtCodMoeda(0);
        setEdtDtPagamento("");
        setTemDebito(item.emdebito);

        if (response.data.valor > 0) {
          setPendencia(true);
          setEdtValor(response.data.valor);
          setEdtValorTemp(response.data.valor);
          setedtCodDetalhe(response.data.coddetalhe);
        } else {
          setPendencia(false);
          setEdtValor(0);
          setedtCodDetalhe(0);
        }
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  async function Recebimento() {
    setLoading(true);

    try {
      await api.post(
        "v1/operacoes/repasse",
        {
          coddetalhe: edtCodDetalhe,
          codcontasreceber: edtCodContasReceber,
          dtlancamento: dtcadastro,
          dtbaixa: edtDtPagamento,
          valorvendido: edtValorVendido,
          perccomissao: edtPercComissao,
          valorempresa: edtValorEmpresa,
          valorbrinde: edtValorBrinde,
          valor: edtValor,
          valorrestante: edtValorRestante,
          codbanco: edtCodBanco,
          codmoeda: edtCodMoeda,
          status: edtStatus,
          descricaoobjeto: edtDescricaoObjeto,
          excluido: "N",
          codusuario: localStorage.getItem("tempCodUsuario"),
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        });
    } catch (err) {
      console.log("Ops! Ocorreu um erro: " + err);
    } finally {
      setLoading(false);
      setshowformValorVenda(false);
      ListarTitulo();
    }
  }

  function InformarRecebimento() {

    if (edtStatus !== "O") {
      setEdtDescricaoObjeto("");
    }

    if (edtStatus === "O" && edtDescricaoObjeto === "") {
      return alert("Informe a descrição do objeto")
    }

    if (edtCodContasReceber === 0) {
      return alert("Volte e selecione o repasse");
    }

    const validarCampos = (campos) => {
      for (let campo of campos) {
        if (!campo.condicao) {
          alert(campo.mensagem);
          return false;
        }
      }
      return true;
    };

    if (edtStatus === "P") {

      const camposSemPendencia = [
        { condicao: edtValorEmpresa !== 0, mensagem: "Informe o Valor da Empresa" },
        { condicao: edtValor !== 0, mensagem: "Informe o valor" },
        { condicao: edtCodBanco !== 0, mensagem: "Informe o Caixa/Banco" },
        { condicao: edtCodMoeda !== 0, mensagem: "Informe a Condição de Pagamento" },
        { condicao: edtDtPagamento !== "", mensagem: "Informe a Data de Pagamento" }
      ];

      const camposComPendencia = [
        { condicao: edtCodBanco !== 0, mensagem: "Informe o Caixa/Banco" },
        { condicao: edtValor !== 0, mensagem: "Informe o valor" },
        { condicao: edtCodMoeda !== 0, mensagem: "Informe a Condição de Pagamento" },
        { condicao: edtDtPagamento !== "", mensagem: "Informe a Data de Pagamento" }
      ];

      const campos = pendencia ? camposComPendencia : camposSemPendencia;

      if (!validarCampos(campos)) return;

      return Recebimento();
    }

    if (edtStatus === "A") {
      if (edtValorEmpresa === 0) {
        return alert("Informe o Valor da Empresa");
      }
      return Recebimento();
    }

    if (edtStatus === "N") {
      return Recebimento();
    }

    if (edtStatus === "D") {
      if (edtValorEmpresa > 0) {
        return alert("Não é para informar o valor");
      }
      return Recebimento();
    }

    if (edtStatus === "O"){
      if (edtValor === 0){
        return alert("Informe o valor");
      }
      return Recebimento();
    }

    return Recebimento();
  }

  function ListarMoeda() {
    api
      .get("v1/cadastro/moeda", {
        params: {
          busca: "",
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setListaMoeda(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(() => {
    ListarMoeda();
  }, [showformValorVenda]);

  function ListarBanco() {
    api
      .get("v1/cadastro/banco", {
        params: {
          busca: "",
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setListaBanco(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(() => {
    ListarBanco();
  }, [showformValorVenda]);

  return (
    <>
      <Header />

      <div>
        <ModalValorVendido
          isOpen={showformValorVenda}
          onRequestClose={closeModal}
          overlayClassName="modal-overlay"
          className="modal-content modal-xl"
        >
          <div className="row">
            <h2>Informe o Valor da Venda de: {edtNome}</h2>
          </div>
          <div className="row">
            <hr />
          </div>

          <div className="row modal-body">
            <form>
              <div className="row">
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                  <label htmlFor="valorvendido" className="form-label">
                    Valor Vendido
                  </label>
                  <input
                    type="number"
                    id="valorvendido"
                    className="form-control"
                    value={edtValorVendido}
                    onChange={(e) => {
                      setEdtValorVendido(e.target.valueAsNumber);
                      setEdtValorEmpresa(e.target.valueAsNumber);
                    }}
                    disabled={pendencia}
                  />
                </div>

                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                  <label htmlFor="comissao" className="form-label">
                    Perc. Comissão
                  </label>
                  <input
                    type="number"
                    id="comissao"
                    className="form-control"
                    value={edtPercComissao}
                    onChange={(e) => {
                      const newPercComissao = e.target.value;
                      setEdtPercComissao(newPercComissao);
                      setEdtValorEmpresa(
                        Math.round(
                          edtValorVendido -
                          edtValorVendido * (newPercComissao / 100)
                        )
                      );
                      setEdtValor(
                        Math.round(
                          edtValorVendido -
                          edtValorVendido * (newPercComissao / 100)
                        )
                      );
                    }}
                    disabled={pendencia}
                  />
                </div>

                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                  <label htmlFor="valorempresa" className="form-label">
                    Valor Empresa
                  </label>
                  <input
                    type="number"
                    id="valorempresa"
                    className="form-control"
                    value={edtValorEmpresa}
                    onChange={(e) => setEdtValorEmpresa(e.target.valueAsNumber)}
                    disabled
                  />
                </div>

                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                  <label htmlFor="valorbrinde" className="form-label">
                    Valor Brinde
                  </label>
                  <input
                    type="number"
                    id="valorbrinde"
                    className="form-control"
                    value={edtValorBrinde}
                    onChange={(e) => {
                      setEdtValorBrinde(e.target.valueAsNumber);
                    }}
                  />
                </div>
              </div>

              <div className="row">
                <p />
                <hr />
              </div>

              <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div>
                    <label className="form-label">Status</label>
                    <br />
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="status"
                        value="P"
                        onChange={(e) => setEdtStatus(e.target.value)}
                        checked={edtStatus === "P"}
                      />
                      <label className="form-check-label">Pago</label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="status"
                        value="C"
                        onChange={(e) => setEdtStatus(e.target.value)}
                        checked={edtStatus === "C"}
                      />
                      <label className="form-check-label">Por Conta</label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="ativo"
                        value="A"
                        onChange={(e) => setEdtStatus(e.target.value)}
                        checked={edtStatus === "A"}
                      />
                      <label className="form-check-label">Aberto</label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="ativo"
                        value="N"
                        onChange={(e) => setEdtStatus(e.target.value)}
                        checked={edtStatus === "N"}
                      />
                      <label className="form-check-label">Não Visto</label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="ativo"
                        value="D"
                        onChange={(e) => setEdtStatus(e.target.value)}
                        checked={edtStatus === "D"}
                      />
                      <label className="form-check-label">Devolvido</label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="ativo"
                        value="O"
                        onChange={(e) => setEdtStatus(e.target.value)}
                        checked={edtStatus === "O"}
                      />
                      <label className="form-check-label">Objeto</label>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-lg-6 col-md-12 col-sm-12">
                  <label htmlFor="valor" className="form-label">
                    Valor
                  </label>
                  <input
                    type="number"
                    id="valor"
                    className="form-control"
                    value={edtValor}
                    onChange={(e) => {
                      if (pendencia === true) {
                        const newValorRestante = e.target.valueAsNumber;
                        setEdtValorRestante(edtValorTemp - newValorRestante);
                        setEdtValor(newValorRestante);
                      } else {
                        const newValorRestante = e.target.valueAsNumber;
                        setEdtValor(newValorRestante);
                        setEdtValorRestante(edtValorEmpresa - newValorRestante);
                      }
                    }}
                  />
                </div>

                <div className="col-xl-3 col-lg-6 col-md-12 col-sm-12">
                  <label htmlFor="valorrestante" className="form-label">
                    Valor Restante
                  </label>
                  <input
                    type="number"
                    id="valorrestante"
                    className="form-control"
                    value={edtValorRestante}
                    disabled
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                  <label htmlFor="descricaoobjeto" className="form-label">
                    Descrição do Objeto
                  </label>
                  <input
                    type="text"
                    id="descricaoobjeto"
                    className="form-control"
                    value={edtDescricaoObjeto}
                    onChange={(e) => setEdtDescricaoObjeto(e.target.value)}
                    disabled={edtStatus !== 'O'}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <label htmlFor="banco" className="form-label">
                    Localize o Banco/Caixa
                  </label>
                  <select
                    id="banco"
                    className="form-select"
                    value={edtCodBanco}
                    onChange={(e) => setEdtCodBanco(e.target.value)}
                    disabled={edtStatus !== "P" && edtStatus !== "C"}
                  >
                    <option value="0">Escolha o banco/caixa</option>
                    {listaBanco.map(function (ban) {
                      return (
                        <option key={ban.codbanco} value={ban.codbanco}>
                          {ban.banco}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <label htmlFor="moeda" className="form-label">
                    Localize a Condição de Pagamento
                  </label>
                  <select
                    id="moeda"
                    className="form-select"
                    value={edtCodMoeda}
                    onChange={(e) => setEdtCodMoeda(e.target.value)}
                    disabled={edtStatus !== "P" && edtStatus !== "C"}
                  >
                    <option value="0">Escolha a condição de pagamento</option>
                    {listaMoeda.map(function (moe) {
                      return (
                        <option key={moe.codmoeda} value={moe.codmoeda}>
                          {moe.moeda}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>

              <div className="row">
                <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12">
                  <label htmlFor="dtpagamento" className="form-label">
                    Dt. Pagamento
                  </label>
                  <input
                    type="datetime-local"
                    id="dtpagamento"
                    className="form-control"
                    placeholder="dtcadastro"
                    value={edtDtPagamento}
                    onChange={(e) => setEdtDtPagamento(e.target.value)}
                    disabled={edtStatus !== "P" && edtStatus !== "C"}
                  />
                </div>
              </div>
            </form>
          </div>

          {temDebito === "S" ? (
            <div className="alert alert-danger mt-2" role="alert">
              Esse cliente TEM débitos na empresa em aberto.
            </div>
          ) : null}

          <div className="row modal-footer">
            <div className="col-12 mt-3 d-flex justify-content-end">
              <button className="btn btn-danger ms-4" onClick={closeModal}>
                Fechar
              </button>
              <button
                className="btn btn-success ms-4"
                onClick={InformarRecebimento}
              >
                Salvar
              </button>
            </div>
          </div>
        </ModalValorVendido>
      </div>

      {loading && <LoadingScreen />}

      <div className="row">
        <h1 className="ms-4">Lançamento de Repasse</h1>

        <p className="ms-4">
          Rotina para lançar os repasses avulsos dos clientes.
        </p>
        <hr />
      </div>

      <div className="row ps-2 pe-2">
        <div className="col-xl-5 col-lg-6 col-md-6 col-sm-6">
          <label className="form-label" htmlFor="busca">
            Busque aqui
          </label>
          <input
            type="text"
            placeholder="Buscar por: Código, nome ou cpf"
            name="busca"
            id="busca"
            className="form-control me-3"
            value={abusca}
            onChange={(e) => {
              setabusca(e.target.value);
              setOffset(0);
            }}
          />
        </div>

        <div className="col-xl-2 col-lg-3 col-md-3 col-sm-3">
          <label htmlFor="periodo" className="form-label">
            de...
          </label>
          <br />
          <input
            type="date"
            id="periodo"
            className="form-control"
            placeholder="Data Inicio"
            value={dt1}
            onChange={(e) => {
              setdt1(e.target.value);
              setOffset(0);
            }}
          />
        </div>

        <div className="col-xl-2 col-lg-3 col-md-3 col-sm-3">
          <label htmlFor="periodo" className="form-label">
            Para...
          </label>
          <br />
          <input
            type="date"
            id="periodo2"
            className="form-control"
            placeholder="dtnascimento"
            value={dt2}
            onChange={(e) => {
              setdt2(e.target.value);
              setOffset(0);
            }}
          />
        </div>

        <div className="col-sm-3">
          <label className="form-label">Tipo de Pano</label>
          <br />
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="tipopano"
              value="T"
              onChange={(e) => setTipoPano1(e.target.value)}
              checked={tipoPano1 === "T"}
            />
            <label className="form-check-label">Todos</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="tipopano"
              value="S"
              onChange={(e) => setTipoPano1(e.target.value)}
              checked={tipoPano1 === "S"}
            />
            <label className="form-check-label">Simples</label>
          </div>

          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="tipopano"
              value="E"
              onChange={(e) => setTipoPano1(e.target.value)}
              checked={tipoPano1 === "E"}
            />
            <label className="form-check-label">Especial</label>
          </div>

          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="tipopano"
              value="O"
              onChange={(e) => setTipoPano1(e.target.value)}
              checked={tipoPano1 === "O"}
            />
            <label className="form-check-label">Ouro</label>
          </div>

          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="tipopano"
              value="P"
              onChange={(e) => setTipoPano1(e.target.value)}
              checked={tipoPano1 === "P"}
            />
            <label className="form-check-label">Prata</label>
          </div>

          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="tipopano"
              value="B"
              onChange={(e) => setTipoPano1(e.target.value)}
              checked={tipoPano1 === "B"}
            />
            <label className="form-check-label">Bronze</label>
          </div>

          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="tipopano"
              value="M"
              onChange={(e) => setTipoPano1(e.target.value)}
              checked={tipoPano1 === "M"}
            />
            <label className="form-check-label">Maleta</label>
          </div>

          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="tipopano"
              value="L"
              onChange={(e) => setTipoPano1(e.target.value)}
              checked={tipoPano1 === "L"}
            />
            <label className="form-check-label">Platinado</label>
          </div>
        </div>
      </div>

      <div className="row ps-2 pe-2">
        <div className="col-xl-4 col-lg-5 col-md-5 col-sm-5">
          <label htmlFor="equipe" className="form-label">
            Equipe
          </label>
          <input
            type="text"
            className="form-control"
            value={inputValue}
            onChange={handleInputChangeEquipe}
          />
          <ul className="autocomplete-list">
            {listaequipe.map((equipe) => (
              <li
                key={equipe.codequipe}
                onClick={() => handleEquipeSelecionado(equipe)}
              >
                {equipe.descricao}
              </li>
            ))}
          </ul>
        </div>

        <div className="col-xl-4 col-lg-5 col-md-5 col-sm-5">
          <label htmlFor="equipe" className="form-label">
            Vendedor
          </label>
          <input
            type="text"
            className="form-control"
            value={inputValue1}
            onChange={handleInputChangeVendedor1}
          />
          <ul className="autocomplete-list">
            {listaVendedor1.map((ven) => (
              <li
                key={ven.codfuncionario}
                onClick={() => handleVendedor1Selecionado(ven)}
              >
                {ven.nome}
              </li>
            ))}
          </ul>
        </div>

        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
          <label htmlFor="cidade" className="form-label">
            Cidade
          </label>
          <input
            type="text"
            className="form-control"
            value={inputValue2}
            onChange={handleInputChangeCidade}
          />
          <ul className="autocomplete-list">
            {listacidade.map((cid) => (
              <li key={cid.cidade} onClick={() => handleCidadeSelecionado(cid)}>
                {cid.cidade} - {cid.uf}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="row mt-3">
        <hr />
      </div>

      <div className="row tabela">
        <table className="col-sm-12 table table-hover">
          <thead>
            <tr>
              <th>Código</th>
              <th>Entrega</th>
              <th>Vencimento</th>
              <th>Cliente</th>
              <th>Cidade</th>
              <th>Equipe</th>
              <th>Vendedor</th>
              <th>Tipo</th>
              <th>Pano</th>
              <th>Qtde Peças</th>
              <th>Qtde Itens</th>
              <th>Valor do Pano</th>
              <th>Ação</th>
            </tr>
          </thead>
          <tbody>
            {lista.map((item) => (
              <tr key={item.codcontasreceber}>
                <th>{item.codcontasreceber}</th>
                <th>{FormataData(item.dtentragapano)}</th>
                <th>{FormataData(item.dtvencimento)}</th>
                <th>{item.cliente}</th>
                <th>
                  {item.cidade} - {item.uf}
                </th>
                <th>{item.equipe}</th>
                <th>{item.vendedor}</th>
                <th>{item.tipo}</th>
                <th>{item.tipopano}</th>
                <th>{item.qtdepeca}</th>
                <th>{item.qtdeitens}</th>
                <th>
                  {parseFloat(item.valorpano).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </th>
                <th>
                  <div className="d-flex justify-content-center">
                    <button
                      className="btn fa-regular fa-pen-to-square"
                      onClick={() => openModalValorVendido(item)}
                      disabled={!podeInserir("/operacoes/lanctitulo")}
                    ></button>
                  </div>
                </th>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="3">Quantidade de linhas: {lista.length}</td>
              <td colSpan="5">
                Total:{" "}
                {lista
                  .reduce(
                    (total, item) => total + parseFloat(item.valorpano),
                    0
                  )
                  .toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
              </td>
            </tr>
          </tfoot>
        </table>
        <div className="row">
          <Paginacao
            limit={20}
            total={qtdetotalpag}
            offset={offset}
            setOffset={setOffset}
          />
        </div>
      </div>
    </>
  );
}

export default LancTitulo;
